import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { ManageEventHubVM } from './manage-event-hub.viewmodel';
import { ManageEventHubPresentation } from './manage-event-hub.presentation';
import { connectEventHubsVM } from '../event-hubs.context';

type ManageEventHubProps = {
    accountId: number;
    eventHubId: number;
};

export const ManageEventHubContainer = withViewModel<ManageEventHubProps, ManageEventHubVM>(ManageEventHubPresentation, async props => {
    const vm = new ManageEventHubVM(props.accountId, props.eventHubId);
    await vm.initialize();

    return vm;
}, props => [props.accountId, props.eventHubId], vm => vm.shutdown());

export const ManageEventHub = connectEventHubsVM<ManageEventHubProps>(ManageEventHubContainer, vm => {
    return {
        accountId: vm.getAccountId(),
        eventHubId: vm.getEventHubId()
    };
});